// extracted by mini-css-extract-plugin
export default {"emoji":"RxFLHgTzvPrKN9H1GEqr","emojiText":"VjIYy1PLped7c_sFZ5xK"};